import { useEffect, useState } from "react";
import { API_URL } from "../config";

export function useFilteredImages({ limit, deleted, filters, endpoint = "/api/images", after, afterId, refreshKey }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const url = new URL(API_URL + endpoint);
    url.searchParams.append("limit", limit);
    url.searchParams.append("deleted", deleted);

    if (after) url.searchParams.append("after", after);
    if (afterId != null) url.searchParams.append("after_id", afterId);
    if (filters.labels?.length) url.searchParams.append("labels", filters.labels.join(","));
    if (filters.keywords?.length) url.searchParams.append("keywords", filters.keywords.join(","));
    if (filters.keywords_mode) url.searchParams.append("keywords_mode", filters.keywords_mode);
    if (filters.prompts?.length) url.searchParams.append("prompts", filters.prompts.join(","));
    if (filters.sort_by) url.searchParams.append("sort_by", filters.sort_by);
    if (filters.sort_direction) url.searchParams.append("sort_direction", filters.sort_direction);

    setLoading(true);
    const controller = new AbortController();
    fetch(url.toString(), { signal: controller.signal })
      .then((res) => res.json())
      .then((data) => {
        setImages(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("Error fetching images:", err);
          setImages([]);
          setLoading(false);
        }
      });
    return () => controller.abort();
  }, [after, afterId, limit, deleted, filters, endpoint, refreshKey]);

  return { images, loading };
}
